import React from 'react';


const TermsPage = () => {
    return (
        <div className="privacy-page">
            <div className="container">
                <h1>Terms Of Service</h1>
                <p>These Terms of Service (the “Terms” or “Terms of Service”) govern your access to and use of the
                    zenzzz.online website and any other applications, content, products, and services (collectively, the
                    “Service”) made available by Zenzzz Health LLC, including its representatives, affiliates, officers,
                    and directors (collectively, “Zenzzz Health,” “us,” “we,” or “our”). These Terms apply to all users
                    of the website, including but not limited to browsers, vendors, customers, merchants, and
                    contributors of content.</p>
                <p><strong>PLEASE READ THESE TERMS CAREFULLY.</strong> BY USING THIS WEBSITE, YOU ACKNOWLEDGE THAT YOU
                    HAVE READ AND ACCEPT THESE TERMS. IF YOU DO NOT AGREE TO BE BOUND BY THESE TERMS, DO NOT ACCESS,
                    BROWSE, OR USE THE SERVICES.</p>
                <hr/>
                <h3>1. Online Store Terms</h3>
                <p>By agreeing to these Terms, you represent that you are at least the age of majority in your state or
                    province of residence or that you have obtained consent to allow your minor dependents to use this
                    site.</p>
                <p>You may not use our products for illegal or unauthorized purposes or violate any laws in your
                    jurisdiction (including copyright laws) while using the Service. You must not transmit viruses,
                    worms, or destructive code.</p>
                <p>Any breach of these Terms will result in immediate termination of Services.</p>
                <hr/>
                <h3>2. General Conditions</h3>
                <p>We reserve the right to refuse Service to anyone for any reason at any time.</p>
                <p>You understand that your content (not including credit card information), may be transferred
                    unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and
                    adapt to technical requirements of connecting networks or devices. Credit card information is always
                    encrypted during transfer over networks.</p>
                <p>You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use
                    of the Service, or access to the Service or any contact on the website through which the Service is
                    provided, without express written permission by us.</p>
                <p>The headings used in this agreement are included for convenience only and will not limit or otherwise
                    affect these Terms.</p>
                <hr/>
                <h3>3. Accuracy of Information</h3>
                <p>While Zenzzz Health strives for accuracy, we do not guarantee that the information on this site is
                    complete, current, or error-free. Reliance on the material is at your own risk.</p>
                <p>We reserve the right to modify content at any time and are not obligated to update information,
                    except as required by law.</p>
                <hr/>
                <h3>4. Modifications to Services and Pricing</h3>
                <p>Prices are subject to change without notice. We reserve the right to modify or discontinue the
                    Service without prior notice and will not be liable for such changes.</p>
                <hr/>
                <h3>5. Products and Services</h3>
                <p>Certain items may be available exclusively online and are subject to our Return Policy. We reserve
                    the right to:</p>
                <ul>
                    <li>Refuse or limit orders at our discretion.</li>
                    <li>Cancel or modify orders for reasons such as duplicate accounts or suspected resale.</li>
                </ul>
                <p>Product descriptions and prices may change at any time. We do not guarantee that products or services
                    will meet your subjective expectations.</p>
                <hr/>
                <h3>6. Billing and Account Information</h3>
                <p>You agree to provide accurate and up-to-date billing and account details for purchases. Fraudulent or
                    unauthorized transactions will result in cancellation.</p>
                <p>Please promptly update your information to ensure seamless transactions.</p>
                <hr/>
                <h3>7. Payments and Subscriptions</h3>
                <p>Subscriptions will auto-renew unless canceled. By providing a payment method, you authorize recurring
                    charges, including applicable taxes.</p>
                <p>Please refer to our <a href="/refund"><strong>Refund
                    Policy</strong></a> for subscription-related refunds or cancellations.</p>
                <hr/>
                <h3>8. Optional Tools</h3>
                <p>We may offer access to third-party tools "as is," without warranties or liability. Use these tools at
                    your discretion.</p>
                <hr/>
                <h3>9. Third-Party Links</h3>
                <p>Our site may contain links to third-party content, which are not affiliated with zenzzz Health. We are
                    not responsible for their content, accuracy, or any harm resulting from their use.</p>
                <hr/>
                <h3>10. User Comments</h3>
                <p>By submitting comments, you grant us the unrestricted right to edit, publish, and distribute them.
                    You are responsible for ensuring that your comments do not violate third-party rights or contain
                    harmful material.</p>
                <hr/>
                <h3>11. Personal Information</h3>
                <p>Your submission of personal information is governed by our <a
                    href="/privacy" target="_blank" rel="noopener">Privacy
                    Policy.</a></p>
                <hr/>
                <h3>12. Prohibited Uses</h3>
                <p>You agree not to use the site for unlawful, abusive, or harmful purposes, including, but not limited
                    to, harassment, fraud, or distributing malware.</p>
                <hr/>
                <h3>13. Disclaimer of Warranties and Limitation of Liability</h3>
                <p>The Service is provided "as is" without warranties. zenzzz Health is not liable for direct or indirect
                    damages arising from the use of the Service, except as required by law.</p>
                <hr/>
                <h3>14. Indemnification</h3>
                <p>You agree to indemnify zenzzz Health from any claims or liabilities arising from your breach of these
                    Terms.</p>
                <hr/>
                <h3>15. Health Disclaimer</h3>
                <p>zenzzz Health is not a medical professional. The Services are not a substitute for medical advice or
                    emergency care.</p>
                <hr/>
                <h3>16. Agreement to Arbitrate</h3>
                <p>You agree to resolve disputes exclusively through arbitration, waiving your right to participate in
                    class actions. Opt-out instructions are provided within these Terms.</p>
                <hr/>
                <h3>17. Governing Law</h3>
                <p>These Terms are governed by the laws of the State of New York.</p>
                <hr/>
                <h3>18. Changes to Terms</h3>
                <p>We reserve the right to modify these Terms at any time. Your continued use of the site indicates
                    acceptance of the changes.</p>
                <hr/>
                <h3>19. Severability</h3>
                <p>If any provision of these Terms is deemed unenforceable, the remaining provisions remain in
                    effect.</p>
                <hr/>
                <h3>20. Entire Agreement</h3>
                <p>These Terms, along with our Privacy Policy and Return Policy, constitute the entire agreement between
                    you and zenzzz Health.</p>
                <hr/>
                <h3>21. Termination</h3>
                <p>You may terminate these Terms by ceasing use of our Services. zenzzz Health may terminate these Terms
                    for violations or at its discretion.</p>
                <hr/>
                <h3>22. Contact Information</h3>
                <p>For questions, contact us at <strong><a href="mailto:support@zenzzz.online">support@zenzzz.online</a></strong>.
                </p>


            </div>
        </div>
    );
};

export default TermsPage;